"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Quay = void 0;
const api = __importStar(require("./helpers/api"));
const url_1 = require("./helpers/url");
const Message_1 = require("./models/Message");
class Quay {
    constructor(quayUrl) {
        if (!quayUrl)
            throw new Error('QUAY_URL_MISSING');
        this.quayUrl = quayUrl;
    }
    /**
     * Returns the current global active messages for the user.
     *
     * @return {*}  {Promise<Message[]>}
     * @memberof Icebox
     */
    async getActiveGlobalMessages() {
        const result = await api.get((0, url_1.buildFullyQualifiedUrl)(this.quayUrl, 'messages/active'));
        return result.messages.data.map((row) => new Message_1.Message(row));
    }
}
exports.Quay = Quay;
//# sourceMappingURL=quay.js.map